export default {
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      numero: ''
    }
  },
  computed: {
    inputInvalido () {
      return !this.numero.length;
    },
  },
  methods: {
    params() {
      return {
        numero: this.numero,
        query: {
          token_id: this.token,
        }
      };
    }
  },
}
